import { useStaticQuery, graphql } from "gatsby"

export const useMetaCollectionOnline = () => {
  return useStaticQuery(graphql`
    query MetaCollectionOnline {
      online: markdownRemark(
        fields: {
          contentKind: { eq: "meta" }
          slug: { eq: "collection/online" }
        }
      ) {
        html
        plain: excerpt(format: PLAIN, truncate: false)
      }
    }
  `).online
}
